import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
  ServerError,
} from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { createApolloProvider } from '@vue/apollo-option';
import router from '../router';
import {
  fetchRefreshedAccessTokens,
  tokenExpiresInFiveMins,
} from '../services/auth';
import store from '../store';

const httpLink = new HttpLink({
  uri: `${process.env.VUE_APP_API_DOMAIN}/graphql`,
});

const publicHttpLink = new HttpLink({
  uri: `${process.env.VUE_APP_API_DOMAIN}/public/graphql`,
});

// attach our access token and also refresh the token if its close
// to expiring.
const authMiddleware = setContext(async (_, { headers }) => {
  // check to see if our token will expire in 5 minutes
  // if so refresh, update local storage and our store
  let token = localStorage.getItem('crate.auth.access_token');
  const refreshToken = localStorage.getItem('crate.auth.refresh_token');
  if (token && refreshToken && tokenExpiresInFiveMins(token)) {
    console.log('refreshing our access token from middleware');
    const res: any = await fetchRefreshedAccessTokens(refreshToken);
    localStorage.setItem('crate.auth.access_token', res.data.access_token);
    token = res.data.access_token;
    store.commit('setAuthAccessToken', token);
  }
  return {
    headers: {
      ...headers,
      authorization: token || null,
    },
  };
});

const logoutLink = onError(({ networkError }) => {
  if (networkError && (networkError as ServerError).statusCode === 401) {
    store.dispatch('logoutUser').then(() => {
      router.push('/login');
    });
  }
});

export const apolloClient = new ApolloClient({
  link: ApolloLink.from([authMiddleware, logoutLink, httpLink]),
  cache: new InMemoryCache(),
  connectToDevTools: true,
});

const publicClient = new ApolloClient({
  link: publicHttpLink,
  cache: new InMemoryCache(),
});

export const apolloProvider = createApolloProvider({
  defaultClient: apolloClient,
  clients: {
    publicClient,
  },
});
